/**
 * Activity Dashboard Service
 *
 * Henter lenken til Master Admins aktivitetsdashbord (storskjerm) for innlogget tenant.
 * URL-en inneholder tenantens visningsnøkkel og bygges ferdig i backend
 * (ActivityDashboardController) — nøkkelen skal ikke håndteres separat i frontend.
 * Endepunktet er begrenset til lagersjef/administrator (403 for operatører).
 */

import { ApiClient } from './apiClient';
import { AuthService } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

/**
 * Returnerer ferdig storskjerm-URL for innlogget tenant.
 * Kaster ved manglende tilgang (403), manglende visningsnøkkel (404) eller andre feil.
 */
export async function getActivityDashboardLink(): Promise<string> {
  const userData = AuthService.getUserDataFromToken();
  if (!userData?.companyNo) {
    throw new Error('Ingen brukerdata tilgjengelig');
  }

  const response = await ApiClient.get(`${API_BASE_URL}/${userData.companyNo}/activity-dashboard-link`);
  if (!response.ok) {
    throw new Error(`Kunne ikke hente aktivitetsdashbord-lenke (${response.status})`);
  }

  const data: { url: string } = await response.json();
  return data.url;
}
